import React from "react";
import {Dialog} from "primereact/dialog";
import {baseUrl} from "../utils/webInfo";




const LocationModal = ({visible, setVisible, position, setPosition}: any) => {

    console.log("baseUrl", baseUrl)

    return (
        <Dialog
            header="Location"
            visible={visible}
            className="w-11 sm:w-10 lg:w-6 xl:w-5"
            onHide={() => {
                setVisible(false);
                setPosition(null)
            }}
        >
            {
                position?.latitude && position?.longitude ?
                    <iframe
                        className={"w-full"}
                        style={{height: "70vh"}}
                        loading="lazy"
                        allowFullScreen
                        referrerPolicy="no-referrer-when-downgrade"
                        src={`https://www.google.com/maps/embed/v1/place?q=${position.latitude},${position.longitude}&key=${baseUrl?.map_api_key}&zoom=18&maptype=roadmap`}
                    >

                    </iframe>
                    :

                    <div>
                        <div className={"flex align-items-center"}>
                            <img
                                src="/utilities/images/location.png"
                                className="h-10rem w-auto mx-auto opacity-50"
                                alt=""
                            />
                        </div>
                        <h1 className="text-xl text-center">No location found</h1>
                    </div>

            }
        </Dialog>
    );
};

export default LocationModal;
